import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { Icon } from "capitalrx-components-2.0/lib/general";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Subtitle } from "capitalrx-components-2.0/lib/typography";

import { ExperienceContext, MemberEligibilityContext } from "@/App/context";
import { getCustomerSupportNumber } from "@/App/utils/utils";
import styled from "styled-components";

export const CustomerSupportIcon = styled(Icon)`
  width: 48px;
  height: 48px;

  max-height: unset !important;
  max-width: unset !important;
`;

export const CustomerSupport: FC = () => {
  const { t: translate } = useTranslation();
  const { memberEligibility } = useContext(MemberEligibilityContext);
  let { customerSupportHours } = useContext(ExperienceContext);
  const { customerSupportPhoneNumber } = useContext(ExperienceContext);
  const customerSupportNumber = getCustomerSupportNumber(memberEligibility, customerSupportPhoneNumber);

  // hacks! there's no override for showing or hiding this currently
  if (!customerSupportHours && memberEligibility?.plan.client_id !== "BSWCARE") {
    customerSupportHours = translate("CUSTOMER_SUPPORT.weAreHere");
  }

  return (
    <Stack style={{ flexGrow: 1 }} alignment="center" spacing="small" testId="customer-support-container">
      <Stack.Spacer />
      <CustomerSupportIcon name="phone" size="large" />
      <Subtitle textAlign="center">{translate("CUSTOMER_SUPPORT.customerSupport")}</Subtitle>
      <Subtitle testId="customer-support-number" textAlign="center">
        {customerSupportNumber}
      </Subtitle>
      {customerSupportHours && (
        <Body textAlign="center">{customerSupportHours}</Body>
      )}
      <Stack.Spacer />
    </Stack>
  );
};
